<template>
    <div v-if="isButtonVisible == false">
        <a v-if="userType == 'B2C'  && (countryId == '2' || countryId == '3') && !isButtonVisible"
            href="/where-to-buy"
            class="btn btn-wishlist-outlined btn-hover"
            :disabled="isDisabled"
            :class="wishListClass"
            >{{ label_find_a_dealer }}</a>
    </div>
</template>

<script>
import { getCartUrl, intToBool } from "../../store/modules/helpers";

export default {
    name: "find-a-dealer",
    props: {
        items: {},
        data: {},
        netsuite_url: {},
        netsuite_app_url: {},
        getPackageComponents_url: {},
        request_a_quote: {
            type: String,
            default: "Add to Wish List"
        },
        added_to_quote_request: {
            type: String,
            default: "Added to Wish List"
        },
        add_to_wishlist: {
            type: String,
            default: "Add to Wish List"
        },
        added_to_wishlist: {
            type: String,
            default: "Added to Wish List"
        },
        label_view_wishlist: {
            type: String,
            default: "View Wish List"
        },
        label_view_quote_list: {
            type: String,
            default: "View Wish List"
        },
        label_continue_shopping: {
            type: String,
            default: "Continue Shopping"
        },
        label_find_a_dealer: {
        type: String,
        required: true,
        default: "Find a Dealer",
        },
        ga_tracking_category: {
            type: String,
            default: "WishList"
        },
        ga_tracking_action: {
            type: String,
            default: "Click"
        },
        ga_tracking_label: {
            type: String,
            default: "Button"
        },
        enable_b2c: {},
        enable_b2b: {},
    },
    data() {
        return {
            cartmode: false,
            isDisabled: false,
            added: false,
            showModal: false,
            userType: 'B2C',
            countryId: 4,
            item: null,
            apiData: null,
            currency: window.currency,
        };
    },
    mounted() {
        this.isB2bUser();
        this.fetchProductDetails();
        if (window.culture == 'en-au') {
            this.countryId = 3;
        }
        else if ((window.culture == 'en-us') || (window.culture == 'es-us')) {
            this.countryId = 4;
        }
        else if (window.culture == 'en-nz') {
            this.countryId = 2;
        }
        else if ((window.culture == 'en-de') || (window.culture == 'de-de')) {
            this.countryId = 1;
        }
        else if ((window.culture == 'en-ca') || (window.culture == 'fr-ca')) {
            this.countryId = 5;
        }
        else{
            this.countryId = 4;
        }

        if(this.dealer_set == "1" ){
            this.isb2c = false;
        }else{
            this.isb2c = true;
        }

        var enables = new Object();
        enables["enable_b2b"] = this.enable_b2b;
        enables["enable_b2c"] = this.enable_b2c;
        if (this.data.netSuiteId) {
            this.$store
                .dispatch("auth/isCartMode", enables)
                .then(data => {
                this.cartmode = data;
            })
            .catch(error => {});
        }
    },
    methods: {
        isB2bUser() {
            this.userType = this.$store.getters["auth/userType"]; 
        },
        addToWishList() {
            this.showModal = true;
            this.$store.commit("wishlist/addItem", this.data.stockCode);
            this.added = true;
            ga('send', 'event', this.ga_tracking_category, this.ga_tracking_action, this.ga_tracking_label);
            gtag('event',  this.ga_tracking_category, {'category': this.ga_tracking_category, 'action':this.ga_tracking_action +  ' Spec', value:this.ga_tracking_label});
        },
        closeModal() {
            this.showModal = false;
        },
        setCartCount(count) {
          this.$store.commit("wishlist/setCartCount", count);
        },
        addItemTocart(items) {
          if(items && items.length) items.reverse();
          console.log('addItemTocart', items)
          this.isDisabled = true;
          let vm = this;

          var data = [];
          for(var i = 0; i < items.length; i++) {
            if (this.data && this.data.quantity) {
              items[i].qty = items[i].qty * this.data.quantity;
            }
            data.push(
              items[i].isPackage
                ? this.ProductData(
                    items[i].netSuiteId,
                    items[i].qty,
                    "NonInvtPart",
                    items[i].hasPackages
                  )
                : this.ProductData(items[i].netSuiteId, items[i].qty, "Assembly", items[i].hasPackages)
            );
          }

          jQuery
            .ajax({
              url: this.addToCartUrl,
              method: "POST",
              data: JSON.stringify(
                data
              ),
              xhrFields: {
                withCredentials: true
              }
            })
            .done(function(res) {
              if (res.errorMessage) {
                alert(
                  "Adding this item caused an error",
                );
                console.log("Error response", res);
              } else {
                let qtys = res.lines.map(obj => {
                  return obj.quantity;
                });

                vm.setCartCount(eval(qtys.join("+")));
              }
              vm.isDisabled = false;
              vm.added = true;
              for(var i = 0; i < items.length; i++) {
                  if (items[0].isPackage) vm.$emit("removeFromWishlist", vm.data.stockCode);
              }
            })
            .fail(function(err) {
              alert("An error has occurred adding to cart");
              vm.isDisabled = false;
              console.log(err.responseJSON);
            });
        },
        addToCartWishList() {
          this.showModal = true;
          let vm = this;

          jQuery
            .ajax({
              url: vm.getPackageComponentsUrl,
              method: "GET",
              xhrFields: {
                withCredentials: true
              }
            })
            .done(function(res) {
              if (res.success === true) {
                // console.log("getPackageComponentsUrl", res.data);
                var cartItems = [];
                if (res.data.length) {
                  if (!vm.data.netSuiteId) {
                    alert("cant add this -> no netSuiteId");
                  } else {
                    cartItems.push({netSuiteId: vm.data.netSuiteId, qty: 1, isPackage: true, hasPackages: true});
                  }

                  res.data.forEach(function(PackageComponent) {
                    cartItems.push({netSuiteId: PackageComponent.netSuiteId, qty: PackageComponent.qty, isPackage: null, hasPackages: true});
                  });
                } else {
                  if (!vm.data.netSuiteId) {
                    alert("cant add this -> no netSuiteId");
                  } else {
                    cartItems.push({netSuiteId: vm.data.netSuiteId, qty: 1, isPackage: true, hasPackages: false});
                  }
                }

                vm.addItemTocart(cartItems);
              }
            })
            .fail(function(err) {
              alert("An error has occurred adding to cart");
              vm.isDisabled = false;
              console.log(err.responseJSON);
            });
        },
        ProductData(
          netSuiteId = null,
          quantity = 1,
          type = "Assembly",
          hasPackages = null
        ) {
          var product = new Object();
          product["internalid"] = netSuiteId ? netSuiteId : this.data.netSuiteId;
          product["type"] = type;

          var item = new Object();
          item["item"] = product;
          item["quantity"] = quantity;
          if (hasPackages == true)
            item["options"] = [
              {
                cartOptionId: "custcol_rr_pmisca",
                itemOptionId: "",
                label: "PMISCA",
                type: "text",
                value: {
                  internalid: '' + this.data.netSuiteParentId+ '',
                  label: '"' + this.data.netSuiteParentId + '"'
                }
              }
            ];
          else item["options"] = [];
          item["location"] = "";
          item["fulfillmentChoice"] = "ship";
          item["freeGift"] = false;

          return item;
        },
        async fetchProductDetails() {
          let data = await axios.get(this.cartUrl, { withCredentials: true });
          this.apiData = data;
        }
    },
    computed: {
        HasDealer() {
            return this.dealer_set == "1" ? true : false;
        },
        getPackageComponentsUrl() {
            return "/api/getPackageComponents/" + this.data.productId;
        },
        buttonlabel() {
            return !this.added ? this.add_to_wishlist : this.added_to_wishlist;
        },
        wishListClass() {
            return (this.cartmode && !this.HasDealer) ? 'btn-wishlist' : 'btn-wishlist-only';
        },    
        addToCartUrl() {
      return (
        this.netsuite_app_url +
        "services/LiveOrder.Line.Service.ss?c=" + (window.ns_session_var ? window.ns_session_var : "") + "&n=2"
      );
    },
    getPackageComponentsUrl() {
      return (
        (window.culture ? "/" + window.culture : "") +
        "/api/getPackageComponents/" +
        this.data.productId
      );
    },
    buttonlabel() {
      return !this.added
        ? this.label_add_to_cart
        : this.label_added_to_cart;
    },
    cartUrl() {
      return getCartUrl(this.netsuite_url, this.data.netSuiteId, this.components, true);
    },
    components() {
      let components = [];

      if(this.items && this.items.length > 0) {
          components = this.items.map( c => c.netSuiteId);
      }

      components.push(this.data.netSuiteId);

      return components;
    },
    isButtonVisible() {
      let components, netSuiteId, isAlwaysInStock;

      if(this.apiData) {
          components = this.apiData.data.items;
          netSuiteId = this.data.netSuiteId;
          isAlwaysInStock = this.data.isAlwaysInStock;

          return this.$store.getters["cart/isAddToCartButtonVisible"](components, netSuiteId, isAlwaysInStock);
      }

      return false;
    },
    cartUrlParams() {
      return this.$store.getters["cart/getCartUrlParams"] ?? '';
    },
    }
};
</script>

<style scoped>
.modal-wishlist {
    background: #FFF;
    width: 255px;
    height: auto;
    text-align: center;
    position: fixed;
    top: 50%;
    margin-top: -80px;
    left: 50%;
    margin-left: -128px;
    line-height: 25px;
    z-index: 100001;
    padding: 15px;
    border: 1px solid #b65b00;
}
.modal-wishlist h4 {
    font-size: 1.4rem;
}
.modal-wishlist .btn {
    font-size: .9rem;
}
@media (min-width: 768px) and (max-width: 1200px) {
    .modal-wishlist {
        width: 210px;
        margin-top: -115px;
        margin-left: -105px;
    }
    .modal-wishlist h4 {
        font-size: 1.1rem;
    }
    .modal-wishlist .btn {
        padding: 12px 10px 10px;
    }
}

.modal-wishlist .close,
.modal-wishlist .close:hover {
    cursor: pointer;
}
.modal-bg {
    background-color: rgba(0,0,0, .2);
    opacity: .2;
    filter: alpha(opacity=20);
    zoom: 1;

    position: fixed;
    top: 0;
    bottom: 0;
    left: 0;
    right: 0;
    z-index: 100000;
}

.btn-wishlist {
    background-color: #B65B00;
    color: white;
    border: 1px solid #B65B00;
    margin: 0 0 10px;
    width: 22ch;
    
}

.btn-wishlist-outlined {
    background-color: white;
    color: #B65B00;
    border: 1px solid #B65B00;
    width: 22ch;
}

.btn-wishlist-outlined:hover {
    color: white;
}

.btn-wishlist-outlined:hover:after {
  content: "";
  position: absolute;
  z-index: -1;
  top: 0;
  left: 0;
  right: 0;
  bottom: 0;
  background-color: #B65B00;
  transform: scaleX(0);
  transform-origin: 0 50%;
  transition: transform 0.15s ease-out;
}

.btn-hover {
  position: relative;
  transition: all 0.15s;
  transform: perspective(1px) translateZ(0);
  z-index: 1;
}
.btn-hover::before {
  content: "";
  position: absolute;
  z-index: -1;
  top: 0;
  left: 0;
  right: 0;
  bottom: 0;
}
.btn-hover:after {
  content: "";
  position: absolute;
  z-index: -1;
  top: 0;
  left: 0;
  right: 0;
  bottom: 0;
  background-color: #834200;
  transform: scaleX(0);
  transform-origin: 0 50%;
  transition: transform 0.15s ease-out;
}
.btn-hover:hover:after {
  transform: scaleX(1);
}
.btn-hover:disabled {
  transform: none;
}
.btn-hover:disabled:hover:after {
  transform: none;
}


</style>
